import React, {useEffect, useState, useCallback} from 'react';
import { getJudgeName } from "../../utils";

const Phase5 = (props) => {
  const handleUpdatePhotoCard = props.handleUpdatePhotoCard
  const handleCaptionCreate = props.handleCaptionCreate
  const handleCaptionSelected = props.handleCaptionSelected
  const handleGameStateChanged = props.handleGameStateChanged
  const handleSetStale = props.handleSetStale

  const [error, setError] = useState('');
  const [captionSubmitted, setCaptionSubmitted] = useState(false);

  const handleSubmit = async (caption) => {
    if (getJudgeName(props.gameState?.JudgeID, props.gameState, props.gameParticipants) !==
      localStorage.getItem('participantName')) {
      setError("Only the judge can select a winning caption.")
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
      return
    }

    let photoCard = {}
    try {
      photoCard = getPhotoCard(props.gameState?.PhotoCardID)
    } catch (e) {
      console.log("Error getting photo card", e);
    }

    try {
      if (!photoCard?.$id) {
        console.log("Error getting photo card", photoCard);
        setError("There was an error saving your caption.  Please try again.")
        const timer = setTimeout(() => {
          setError('')
          clearTimeout(timer)
        }, 6000);
        return
      }
      handleUpdatePhotoCard(photoCard, true, caption)
    } catch (e) {
      console.log("Error adding player caption", e);
      setError("There was an error saving your caption.  Please try again.")
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
      return
    }

    try {
      handleCaptionSelected(
        localStorage.getItem('participantName'),
        caption.ParticipantName,
        caption.Caption,
        (props.gameState?.AwardedPointsPerWin || 0),
      )
    } catch (e) {
      console.log("Error awarding player points", e);
      setError("There was an error awarding points. Please tell the admin")
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
      return
    }

    try {
      handleGameStateChanged({newPhase: 6})
    } catch (e) {
      console.log("Error changing game state", e);
      setError("There was an error changing the game state. Please tell the admin")
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
    }
  };


  const getPhotoCard = (photoCardId) => {
    for (let i = 0; i < props.photoCards.length; i++) {
      if (props.photoCards[i]["$id"] === photoCardId) {
        return props.photoCards[i]
      }
    }
  }

  const loadCaptions = useCallback(() => {
    if (!!props.isLoadingCaptions || props.captions.length === 0) {
      return (
        <div
          className="w-screen h-screen fixed top-0 left-0 bg-gray-900 opacity-75
          bg-[url('https://media.giphy.com/media/8agqybiK5LW8qrG3vJ/giphy.gif')] bg-center bg-no-repeat z-10">
        </div>
      )
    } else {
      return (
        <div className="grid grid-cols">
          {props.captions.map((caption, _) => {
            return (
              <div
                key={caption.$id}
                className="w-[90%] mx-[5%] mb-4 border border-black rounded-xl grid place-items-center cursor-pointer "
                onClick={() => {
                  handleSubmit(caption)
                }}
              >
                <div className="p-10 text-2xl font-bold text-center text-black">{caption.Caption}</div>
              </div>
            )
          })
          }
        </div>
      )
    }
  }, [props.isLoadingCaptions, props.captions, handleSubmit]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSetStale({stale: true})
    }, 4000);
  }, [])


  return (
    <>
      <div className="mt-[10%] mx-4 border border-black rounded-xl grid place-items-center">
        <div className="p-[5%]">
          <h1 className="text-4xl font-bold text-center text-black">{getJudgeName(props.gameState.JudgeID, props.gameState, props.gameParticipants)}</h1>
        </div>

        <div className="mt-[8px] mb-[10px]">
          {props.captions.length === props.gameParticipants.length &&
            <h3 className="text-gray-950 text-xl">All captions are in</h3>
          }
          {props.captions.length !== props.gameParticipants.length &&
            <h3 className="text-gray-950 text-xl">Time&apos;s up!  Received {props.captions.length}/{props.gameParticipants.length} captions</h3>
          }
        </div>

        <div className="mt-[10px] mb-[12px] mx-10">
          <div className="mx-auto text-gray-950"><span className="font-bold text-xl">{getJudgeName(props.gameState.JudgeID, props.gameState, props.gameParticipants)}</span>: Pick somebody on the team to read them out loud and pick your favorite by clicking on it</div>
        </div>
      </div>

        <div className="mt-4">
          {!!error &&
            <div className="border border-black rounded-lg bg-red-500 m-4 p-4 text-white text-xl">{error}</div>
          }

          <div className="flex justify-center items-center">
            <div className="box relative w-[70%] h-auto bg-[#020223] border border-[15px] border-gray-400 rounded-2xl">
              <img src={getPhotoCard(props.gameState.PhotoCardID)?.ImageUrl} />
            </div>
          </div>

          <div className="mt-[5%] place-items-center">
            {loadCaptions()}
          </div>
        </div>
    </>
  )
}

export default Phase5;
